const secretPatterns = [
    "apiKey",
    "password",
    "privateKey",
    "accessToken",
    "refreshToken",
    "clientSecret",
    "serviceRoleKey",
    "databaseUrl",
    "sshKey",
    "sshPassword",
    "token",
    "secret",
].map((match) => ({
    patternId: `secret-key:${match.toLowerCase()}`,
    label: `Secret-like key: ${match}`,
    category: "secret",
    severity: "critical",
    policy: "blocked",
    match,
    matchMode: "includes",
    messageHindi: `Source text me secret-like key '${match}' mila.`,
    remediationHindi: "Raw secret ya secret field ko contract/source me na rakhen; SecretReference ya metadata-only placeholder use karen.",
    metadata: { secretLikeKey: true },
}));
const rawSecretPatterns = [
    "ghp_",
    "BEGIN OPENSSH PRIVATE KEY",
    "BEGIN RSA PRIVATE KEY",
    "sk-",
    "AKIA",
    "AIza",
].map((match) => ({
    patternId: `raw-secret:${match.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`,
    label: `Raw secret marker: ${match}`,
    category: "secret",
    severity: "critical",
    policy: "blocked",
    match,
    matchMode: "includes",
    messageHindi: `Source text me raw secret marker '${match}' mila.`,
    remediationHindi: "Raw token/private key turant hata kar secret rotation aur safe reference policy use karen.",
    metadata: { rawSecretMarker: true },
}));
rawSecretPatterns.push({
    patternId: "raw-secret:github-pat",
    label: "Raw secret marker: github_pat_",
    category: "secret",
    severity: "critical",
    policy: "blocked",
    match: "github_pat_[A-Za-z0-9_]+",
    matchMode: "regex",
    messageHindi: "Source text me raw GitHub PAT marker 'github_pat_' mila.",
    remediationHindi: "GitHub PAT ko source se hata kar token rotate karen aur safe secret storage use karen.",
    metadata: { rawSecretMarker: true },
});
const blockedEndpointPatterns = [
    "dify.ai",
    "/v1/chat-messages",
    "api.openai.com",
    "generativelanguage.googleapis.com",
    "anthropic.com",
].map((match) => ({
    patternId: `blocked-endpoint:${match.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`,
    label: `Blocked provider endpoint: ${match}`,
    category: "blocked_endpoint",
    severity: "critical",
    policy: "blocked",
    match,
    matchMode: "includes",
    messageHindi: `Source text me blocked provider endpoint '${match}' mila.`,
    remediationHindi: "Real provider endpoint ko metadata-only contract se hata kar server-side safe connector PR me handle karen.",
    metadata: { blockedProviderEndpoint: true },
}));
const executionPatternInputs = [
    { match: "child_process", category: "shell_execution", severity: "critical" },
    { match: "exec(", category: "shell_execution", severity: "critical" },
    { match: "spawn(", category: "shell_execution", severity: "critical" },
    { match: "fetch(", category: "network_execution", severity: "critical" },
    { match: "axios", category: "network_execution", severity: "critical" },
    { match: "WebSocket", category: "network_execution", severity: "critical" },
    { match: "shell.openExternal", category: "desktop_security", severity: "error" },
    { match: "ssh -N", category: "shell_execution", severity: "critical" },
    { match: "ssh_execute", category: "agent_execution", severity: "critical" },
    { match: "shell_execute", category: "agent_execution", severity: "critical" },
    { match: "restore_execute", category: "file_system_execution", severity: "critical" },
    { match: "backup_delete", category: "file_system_execution", severity: "critical" },
    { match: "database_dump", category: "file_system_execution", severity: "critical" },
    { match: "service_restart", category: "agent_execution", severity: "error" },
    { match: "deploy_execute", category: "agent_execution", severity: "critical" },
    { match: "secret_read", category: "secret", severity: "critical" },
    { match: "fs.writeFile", category: "file_system_execution", severity: "critical" },
    { match: "fs.readFile", category: "file_system_execution", severity: "critical" },
];
const executionPatterns = executionPatternInputs.map(({ match, category, severity }) => ({
    patternId: `execution:${match.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`,
    label: `Execution indicator: ${match}`,
    category,
    severity,
    policy: "blocked",
    match,
    matchMode: "includes",
    messageHindi: `Source text me unsafe execution indicator '${match}' mila.`,
    remediationHindi: "PR ko metadata-only/dry-run contract tak simit rakhen; real execution connector alag approval-gated PR me banega.",
    metadata: { executionIndicator: true },
}));
const unsafeStatusPatterns = [
    {
        patternId: "unsafe-status:approved-for-execution",
        label: "Unsafe status: approved_for_execution",
        category: "approval_bypass",
        severity: "critical",
        policy: "blocked",
        match: "approved_for_execution",
        matchMode: "includes",
        messageHindi: "Source text me unsafe approval bypass status 'approved_for_execution' mila.",
        remediationHindi: "Execution approval ko preview/manual/approval_required status se model karen; auto-approved execution status na rakhen.",
        metadata: { approvalBypass: true },
    },
];
export function createDefaultSafetyPatternCatalog() {
    return [
        ...secretPatterns,
        ...rawSecretPatterns,
        ...blockedEndpointPatterns,
        ...executionPatterns,
        ...unsafeStatusPatterns,
    ];
}
export function listBlockedSafetyPatterns() {
    return createDefaultSafetyPatternCatalog().filter((pattern) => pattern.policy === "blocked");
}
export function listAllowedMetadataDomains() {
    return [
        "smartprintcalculator.com",
        "anoopampress.com",
        "drishtikundalimatching.in",
        "salary.smartprintcalculator.com",
        "digital.anoopampress.com",
        "api.anoopampress.com",
    ];
}
//# sourceMappingURL=safetyPatternCatalog.js.map